<template>
  <div class="c-folder-tabs">
    <div
      v-for="tab in tabs"
      :key="tab"
      class="c-folder-tabs__tab"
      :class="{ active: tab === selectedTabLabel }"
      data-testid="folder-tab"
    >
      <div
        class="c-folder-tabs__label"
        :data-testid="`folder-tab-${kebabCase(tab)}`"
        @click="selectTab(tab)"
      >
        <span>{{ tab }}</span>
      </div>
    </div>

    <slot name="action" />
  </div>
</template>

<script setup lang="ts">
import { kebabCase } from "lodash-es";

import { track } from "shared/boot/analytics";

defineProps<{
  selectedTabLabel: string;
  tabs: string[];
}>();

const emit = defineEmits(["select-tab"]);

function selectTab(selectedTab: string): void {
  track(`Selected ${selectedTab} Tab`);

  emit("select-tab", selectedTab);
}
</script>

<style lang="scss" scoped>
.c-folder-tabs {
  display: flex;
  flex-direction: row;
  margin-bottom: -1px;
  z-index: 1;

  &__tab {
    background-color: $hover-background;
    border: 1px solid $hover-background;
    border-bottom: 0;
    border-radius: 10px 10px 0 0;
    min-width: 177px;
    max-width: 225px;
    margin-right: 2px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    overflow: hidden;
    flex: 1 1 100%;
    cursor: default;

    &:not(.active) {
      cursor: pointer;
    }

    &.active {
      background-color: white;
      font-weight: 500;
    }
  }

  &__label {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px 0 8px 16px;
    line-height: 14px;
    height: 34px;
    flex: 1 1 auto;
    overflow: hidden;
  }
}
</style>
